import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '@/composables/useDisableBrowserBack'
import App from './App.vue'
import router from './router';
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import tools from "@/composables/tools";


import { IonicVue } from '@ionic/vue';
import { setAssetPath } from '@stencil/core';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
/* Custom styles */
import './theme/custom.css';


import { currentUserStore } from '@/stores/currentUser'
import { User } from '@/interfaces/User';
import { useProfesorStore } from './stores/profesorStore';
import { useCoordinadorStore } from './stores/coordinadorStore';
import { useAulaStore } from './stores/aulaStore';
import { mainStore } from './stores/mainStore';
import userAuth from './composables/userAuth';
import { UserService } from './services/UserService';
import { enforceFreshDeploy } from '@/utils/deployVersion';


const pinia = createPinia()

if (typeof window !== 'undefined') {
  try {
    const baseHref = document.querySelector('base')?.getAttribute('href') ?? '/';
    setAssetPath(new URL(baseHref, window.location.href).href);
  } catch {
    setAssetPath(`${window.location.origin}/`);
  }
}

const app = createApp(App)
  .use(IonicVue)
  .use(pinia)
  .use(VueAxios, axios)
  .use(router);

moment.locale('es');

app.config.globalProperties.$filters = {
  timeAgo(date: string) {
    return moment(date).fromNow()
  },
  human(date: string) {
    let val = moment(date).format('dddd D')
    val += ' de '
    val += moment(date).format('MMMM')
    return val
  },
}


Promise.all([router.isReady(), enforceFreshDeploy()]).then(() => {
  app.mount('#app');
});

axios.defaults.baseURL = process.env.VUE_APP_SERVICE_URL
axios.defaults.headers.common["Accept"] = "application/json"
if (localStorage.getItem("token"))
  axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const url = String(error.config?.url || '')
      const enLogin = url.includes('login') || router.currentRoute.value.path === '/login'
      if (enLogin) {
        return Promise.reject(error)
      }
      const destino = router.currentRoute.value.fullPath
      userAuth().clearSessionLocal()
      tools().toast('Tu sesión ha caducado', 'warning', 4500)
      if (destino && destino !== '/login') {
        userAuth().saveRedirect(destino)
      }
      router.replace({ path: '/login', query: destino && destino !== '/login' ? { redirect: destino } : {} })
    }
    else if (error.response?.status === 429) {
      console.warn('Rate limit excedido:', error.config?.url);
      // No mostrar toast aquí, dejarlo a los servicios individuales
      // tools().toast('Demasiadas peticiones. Por favor, espera un momento.', 'warning', 3000)
    }
    else if (error.response?.data?.message && !error.config?.skipErrorToast) {
      tools().toast(error.response.data.message, 'danger', 10000)
    }
    return Promise.reject(error);
  });



async function initializeApp() {
  if (!userAuth().hasToken()) {
    return
  }
  mainStore().isLogged = true
  if (currentUserStore().$state.user === null) {
    const myUser = await userAuth().getCurrentUser();
    console.log(myUser)
    currentUserStore().update(myUser);
    localStorage.setItem("user", JSON.stringify(myUser));
  }
  useProfesorStore().updateProfesores();
  useCoordinadorStore().updateCoordinadores();
  useAulaStore().updateAulas();
}

setInterval(() => {
  if (userAuth().hasToken()) {
    UserService.checkAlertas()
  }
}, 4 * 60 * 1000);

initializeApp();

if (userAuth().hasToken()) {
  UserService.checkAlertas()
}

